/**
 * The page's browser tracer provider, held where any module can read it.
 *
 * `otel-browser-config.ts` writes it when `initBrowserTracing` creates the
 * provider and clears it on `shutdownTracing`; `effect-browser-tracer.ts`
 * reads it on every runtime build. The provider lives here rather than in
 * `otel-browser-config.ts` because that module imports
 * `@opentelemetry/context-zone`, and zone.js patches the global `Promise`,
 * `IntersectionObserver` and `ResizeObserver` the moment it loads. Every RPC
 * client imports the Effect tracer bridge, so reading the provider from
 * `otel-browser-config.ts` loaded zone.js and the OTel web SDK on every page,
 * before consent.
 *
 * Only `import type` from the OTel packages here: a value import re-arms the
 * same trap. `__tests__/zone-free-imports.test.ts` pins it.
 */
import type { WebTracerProvider } from "@opentelemetry/sdk-trace-web"

let tracerProvider: WebTracerProvider | null = null

/** The provider `initBrowserTracing` registered, or null before consent and init. */
export function getTracerProvider(): WebTracerProvider | null {
  return tracerProvider
}

/** Written only by `otel-browser-config.ts`: the provider on init, null on shutdown. */
export function setTracerProvider(provider: WebTracerProvider | null): void {
  tracerProvider = provider
}
